import { booleanToText } from 'utils/format';

import BeforeAndAfterWithArrow from './BeforeAndAfterWithArrow';

const VehicleExtra = ({ vehicleExtras = {}, extra, label }) => {
  if (!vehicleExtras || !vehicleExtras?.before || !vehicleExtras?.after) {
    return null;
  }

  const extrasBefore = vehicleExtras?.before;
  const extrasAfter = vehicleExtras?.after;

  const extraBefore = extrasBefore.includes(extra);
  const extraAfter = extrasAfter.includes(extra);

  if (extraBefore === extraAfter) {
    return null;
  }

  return (
    <BeforeAndAfterWithArrow
      label={label}
      before={extraBefore}
      after={extraAfter}
      valueFormatter={(value) => booleanToText(value)}
    />
  );
};

export default VehicleExtra;
